import loadable from '@loadable/component';

const TicketLoadable = loadable(() => import(/* webpackChunkName: "ticket-poli-page" */ './index'));

export default TicketLoadable;
